import { GET } from './NetService';

const Action = "paciente/";

export async function loadAll(bsignal)
{
    return await GET(Action,bsignal);
}

export async function find(bsignal,query)
{
    return await GET(Action+"censo/search/"+query,bsignal);
}

export async function getPatient(bsignal,patientId)
{
    return await GET(Action+patientId,bsignal);
}

export async function getExpediente(bsignal,idexpediente)
{
    return await GET(Action+"censo/expediente/"+idexpediente,bsignal);
}

export async function getCenso(bsignal)
{
    return await GET(Action+"censo/saldo",bsignal);
}

export async function getCensoIngresos(bsignal,datestart,dateend)
{
    return await GET(Action+"censo/ingresos",bsignal,{fechaInicial: datestart, fechaFinal: dateend});
}

export async function getCensoEgresos(bsignal,datestart,dateend)
{
    return await GET(Action+"censo/egresos",bsignal,{fechaInicial: datestart, fechaFinal: dateend});
}

export async function getCensoIngresosCuentas(bsignal,datestart,dateend)
{
    return await GET(Action+"censo/ingresos/cuentas",bsignal,{fechaInicial: datestart, fechaFinal: dateend});
}

export async function getCensoEgresosCuentas(bsignal,datestart,dateend)
{
    return await GET(Action+"censo/egresos/cuentas",bsignal,{fechaInicial: datestart, fechaFinal: dateend});
}

export async function getProcedimientosCuentas(bsignal)
{
    return await GET(Action+"censo/procedimientos/cuentas",bsignal);
}

export async function getProcedimientosCuentasRango(bsignal,datestart,dateend)
{
    return await GET(Action+"censo/procedimientos/rango/cuentas",bsignal,{fechaInicial: datestart, fechaFinal: dateend});
}

export async function getCensoCuentas(bsignal)
{
    return await GET(Action+"censo/saldo/cuentas",bsignal);
}